import { render, staticRenderFns } from "./DetectionUrlModal.vue?vue&type=template&id=cdedf5a4&scoped=true&"
import script from "./DetectionUrlModal.vue?vue&type=script&lang=js&"
export * from "./DetectionUrlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdedf5a4",
  null
  
)

export default component.exports